// import logo from './logo.svg';
import './App.css';
// import useSound from 'use-sound';
//SOUNDS
// import a from './sounds/doh.swf.mp3'
// import b from './sounds/aint-nobody.mp3'
// import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';

// import Avatar from '@material-ui/core/Avatar';
// import AssignmentIcon from '@material-ui/icons/Assignment';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
import { analytics } from './firebase'
// import TagManager from 'react-gtm-module'
 


function App() {
  // const [doh] = useSound(a);
  // const [aintNobody] = useSound(b);
    
  // TagManager.initialize({ gtmId: 'GTM-NX67CK6' })

  const playSound = (name) => {
    const sound = document.getElementById(name)
    sound.play()

    // fadeout and stop sound
    fadeOutSound(sound)

    // analytics
    analytics.logEvent('Play Sound', { name });
  }

  const fadeOutSound = (sound) => { 
    const interval = setInterval( () => {
      const volume = sound.volume
      if ( sound.currentTime > 2 ) {
        if(volume > 0.1) {
          sound.volume = volume - 0.1;
        }
        else{
            // Stop fade
            clearInterval(interval);
            sound.pause();
            sound.currentTime = 0;
            sound.volume = 1;
        }
      }
    }, 150)
  }

  const stopAll = () => {
    const audios = document.getElementsByTagName('audio');
    let i = audios.length;
    while(i--) {
      audios[i].pause()
    }
    analytics.logEvent('Stop Sound');
  }

  return (
    <div className="App">
      <AppBar position="static">
        <Toolbar>
          <Typography variant="body1" >
            Sitcom - Sounds for your calls
          </Typography>
        </Toolbar>
      </AppBar>
          
      <Container>
        <h2>Your sounds - Click them!</h2>  

        <div className="div-sounds" style={{flexGrow: 1}}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound" onClick={() => playSound("clap")}>👏</button>
              <audio id="clap" src="./sounds/applause10.mp3"></audio>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound" onClick={() => playSound("applause")}>🙇 👏👏 🙇</button>
              <audio id="applause" src="./sounds/crowdapplause1.mp3"></audio>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound" onClick={() => playSound("directed")}>🎬  By</button>
              <audio id="directed" src="./sounds/directed_by.mp3"></audio>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound" onClick={() => playSound("sax")}>🎷</button>
              <audio id="sax" src="./sounds/sax.mp3"></audio>
            </Grid>


            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound" onClick={() => playSound("drumRoll")}>🥁</button>
              <audio id="drumRoll" src="./sounds/drum-roll.mp3"></audio>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound secondary" onClick={stopAll}>Stop Sounds</button>
            </Grid>


            <Grid item xs={6} sm={3} md={2}>
              <button className="btn-sound secondary" onClick={() => { alert("This feature is under development. Send any suggestion you may have by using the form on the page."); analytics.logEvent('Add Sound') }}>
                + 
                <br></br>
                Add Your Sounds
              </button>
            </Grid>
          </Grid>

        </div>


          {/* <Button onClick={doh} variant="contained" color="primary">Doh</Button>
          <Button onClick={aintNobody} variant="contained" color="primary">aintNobody</Button> */}
        <Link href="https://www.notion.so/Sitcom-Instructions-1b3d7c8bf3674bbc813e8559f681dae1" target="_blank" rel="noopener">
          Instruction - How to use this app?
        </Link>
        
      </Container>
    </div>
  );
}

export default App;
